import React, {createContext, useReducer} from "react"
import {SblDeviceOverviewReducer} from "../reducer/SblDeviceOverviewReducer";

export const SblDeviceOverviewContext = createContext();

const SblDeviceOverviewContextProvider = (props) => {
    const data = []
    const [viewModel, dispatch] = useReducer(SblDeviceOverviewReducer, data)
    return (
        <SblDeviceOverviewContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </SblDeviceOverviewContext.Provider>
    )
}

export default SblDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/sbldevice/context/SblDeviceOverviewContext.js